module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-down-black-48-dp.9f5de379.svg";